import { render, staticRenderFns } from "./notComplited.vue?vue&type=template&id=ff8c4e28&scoped=true&"
import script from "./notComplited.vue?vue&type=script&lang=js&"
export * from "./notComplited.vue?vue&type=script&lang=js&"
import style0 from "./notComplited.vue?vue&type=style&index=0&id=ff8c4e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8c4e28",
  null
  
)

export default component.exports